import React from 'react';

import { VirtualizedTableRowsWrapperProps } from './types';
import VirtualizedTableHeader from '../VirtualizedTableHeader';
import VirtualizedTableFooter from '../VirtualizedTableFooter';

const VirtualizedTableRowsWrapper = (
    props: VirtualizedTableRowsWrapperProps
): React.ReactElement => {
    const { children, style } = props;

    return (
        <div style={style}>
            <VirtualizedTableHeader />
            <VirtualizedTableFooter tableHeight={style.height as number} />
            {children}
        </div>
    );
};

export default VirtualizedTableRowsWrapper;
